import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603 } from "@faire/web-api--source/indigofair/settings/BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";

import { useIsLoggedInRetailer } from "../lib/isLoggedInRetailer";

export const useSettingBatch10ProductTiles = (): IFourVariantXP.Bucket => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const variant = useSetting(
    BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603,
    IFourVariantXP.Bucket.CONTROL
  ) as IFourVariantXP.Bucket;
  return isLoggedInRetailer ? IFourVariantXP.Bucket.CONTROL : variant;
};

export const whichBatch10ProductTilesVariant = (
  variant: IFourVariantXP.Bucket | undefined
) => {
  return {
    isBatch10ProductTilesControl:
      variant === IFourVariantXP.Bucket.CONTROL ||
      variant === IFourVariantXP.Bucket.BUCKET_UNKNOWN ||
      variant === undefined,
    isBatch10ProductTilesV3: variant === IFourVariantXP.Bucket.VARIANT_3,
    isBatch10ProductTilesV2orV3:
      variant === IFourVariantXP.Bucket.VARIANT_2 ||
      variant === IFourVariantXP.Bucket.VARIANT_3,
    isBatch10ProductTilesV4: variant === IFourVariantXP.Bucket.VARIANT_4,
  };
};
